import actions from './global/actions';
import mutations from './global/mutations';
import getters from './global/getters';

// Article State
const state = {
  login: false,
  profile: null,
  snackBar: {
    active: false,
    color: '',
    text: '',
  },
  accessToken: localStorage.getItem('dc-access') || null,
  refreshToken: localStorage.getItem('dc-refresh') || null,
  msgBox: {},
  rwdType: 'desktop',
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  strict: true,
};
